
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 14V6H9.5A1.48 1.48 0 018 4.5V1H4c-.563 0-1 .469-1 1v12c0 .563.438 1 1 1h8c.531 0 1-.438 1-1zm-.031-9c-.031-.063-.063-.156-.125-.219L9.219 1.156c-.063-.062-.156-.093-.219-.125V4.5c0 .281.219.5.5.5h3.469zM2 2c0-1.094.875-2 2-2h4.875c.375 0 .781.188 1.063.469l3.593 3.594c.281.28.469.687.469 1.062V14c0 1.125-.906 2-2 2H4c-1.125 0-2-.875-2-2V2zm2 .5c0-.25.219-.5.5-.5h2c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-2a.494.494 0 01-.5-.5zm0 2c0-.25.219-.5.5-.5h2c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-2a.494.494 0 01-.5-.5zm4.5 3.125v.438c.25.03.5.062.719.124a.494.494 0 01.375.594.494.494 0 01-.594.375c-.344-.062-.688-.125-1.031-.125-.25-.031-.563.031-.75.156C7.03 9.281 7 9.376 7 9.47c0 .062 0 .125.188.219.218.124.53.187.937.312.344.094.781.219 1.125.406.375.188.719.563.75 1.125 0 .594-.344.969-.75 1.219-.219.125-.5.188-.75.25v.406c0 .281-.25.5-.5.5a.494.494 0 01-.5-.5v-.437a7.293 7.293 0 01-.969-.25c-.062-.031-.125-.031-.187-.063-.25-.062-.407-.344-.344-.625.094-.25.375-.406.625-.344.094.032.156.063.219.094.437.125.781.219 1.156.219a1.47 1.47 0 00.781-.125c.156-.094.219-.219.219-.344 0-.062-.031-.156-.219-.25-.219-.125-.531-.219-.937-.312l-.032-.031c-.343-.094-.75-.188-1.093-.376C6.375 10.376 6 10.033 6 9.47c0-.594.375-.969.75-1.188.25-.125.5-.187.75-.219v-.437c0-.281.219-.5.5-.5s.5.219.5.5z","fill":"#212121"}})])
          )
        }
      }
    